<template>
  <b-form @submit.prevent>
    <b-form-row>
      <b-form-group label="Dziedzina" class="mr-3">
        <b-form-input v-model="filters.domain" type="text" autocomplete="off" />
      </b-form-group>

      <b-form-group label="Tytuł" class="mr-3">
        <b-form-input v-model="filters.title" type="text" autocomplete="off" />
      </b-form-group>

      <b-form-group class="mt-auto">
        <b-button type="submit" class="mr-3" variant="primary" @click="onSearch">Szukaj</b-button>
        <b-button type="submit" class="mr-3" variant="secondary" @click="clear">Wyczyść</b-button>
      </b-form-group>
    </b-form-row>
  </b-form>
</template>
<script>
export default {
  data() {
    return {
      filters: {
        domain: null,
        title: null
      }
    };
  },
  methods: {
    clear() {
      this.filters.domain = null;
      this.filters.title = null;
    },
    onSearch() {
      this.$emit("filters-search", this.filters);
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
